import { API } from "@/services"

export const SIP_FRIENDS_ENDPOINTS = {
  count(params={}){
    return API.Axios.callstats.v1.request({
      url: `sipfriends/count`,
      method: 'GET',
      params,
    })
  },
}